import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

/**
 * RoomBlockSkeleton
 * Mirrors the real "Room Block" layout:
 *  - Header (badge + type pill + actions)
 *  - Room Info (4 fields)
 *  - Extra Facility (4 fields, 2x2) + Room Rent Info (2 fields) side by side
 *
 * Fully responsive: stacks the same way the real layout does
 * (col-xxl-8 / col-xxl-4 → full width below xxl).
 */
export default function RoomBlockSkeleton({ index = 0 }) {
    return (
        <SkeletonTheme baseColor="#e9ecef" highlightColor="#f5f5f5">
            <div className="room-block-card">
                {/* ── Header ── */}
                <div className="room-block-header d-flex align-items-center gap-2">
                    <Skeleton circle width={24} height={24} />
                    <Skeleton width={70} height={16} />
                    <Skeleton width={60} height={20} borderRadius={12} />
                    <div className="ms-auto d-flex gap-2">
                        {index === 0 && <Skeleton width={36} height={36} borderRadius={8} />}
                        <Skeleton width={36} height={36} borderRadius={8} />
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="room-block-body">
                    <div className="d-flex flex-column gap-3">
                        {/* Room Info */}
                        <div className="room-section p-3">
                            <Skeleton width={110} height={18} className="mb-3" />
                            <div className="row g-3">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div className="col-xl-3 col-md-6 col-12" key={i}>
                                        <Skeleton width={90} height={14} className="mb-2" />
                                        <Skeleton height={40} borderRadius={8} />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Extra Facility + Room Rent Info */}
                        <div className="row g-3">
                            {/* Extra Facility */}
                            <div className="col-xxl-8 col-12">
                                <div className="room-section h-100 p-3">
                                    <Skeleton width={130} height={18} className="mb-3" />
                                    <div className="row g-3">
                                        {Array.from({ length: 4 }).map((_, i) => (
                                            <div className="col-md-6 col-12" key={i}>
                                                <Skeleton width={110} height={14} className="mb-2" />
                                                <Skeleton height={40} borderRadius={8} />
                                            </div>
                                        ))}
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <Skeleton width={160} height={14} />
                                        <Skeleton width={90} height={34} borderRadius={8} />
                                    </div>
                                </div>
                            </div>

                            {/* Room Rent Info */}
                            <div className="col-xxl-4 col-12">
                                <div className="room-section h-100 p-3">
                                    <Skeleton width={120} height={18} className="mb-3" />
                                    <div className="row g-3">
                                        <div className="col-6">
                                            <Skeleton width={80} height={14} className="mb-2" />
                                            <Skeleton height={40} borderRadius={8} />
                                        </div>
                                        <div className="col-6">
                                            <Skeleton width={100} height={14} className="mb-2" />
                                            <Skeleton height={40} borderRadius={8} />
                                        </div>
                                    </div>

                                    {/* Rate breakdown rows */}
                                    <div className="mt-3 d-flex flex-column gap-2">
                                        <div className="d-flex justify-content-between">
                                            <Skeleton width="55%" height={14} />
                                            <Skeleton width="20%" height={14} />
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <Skeleton width="45%" height={14} />
                                            <Skeleton width="20%" height={14} />
                                        </div>
                                        <div className="d-flex justify-content-between pt-2 border-top">
                                            <Skeleton width="35%" height={16} />
                                            <Skeleton width="25%" height={16} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}